import type { Nullable } from "@/types/nullable";
import type { ImageSourceSetsRecord } from "@/types/of-image.types";
import { MatchEventPenaltyShootout_KickType } from "@motain/xpa-proto-files-web/lib/types/match_events";
import { pxIcon } from "@/utils/helpers/pxIcon";

export const getPenaltyShootoutIcon = (
  type: MatchEventPenaltyShootout_KickType,
): Nullable<string | ImageSourceSetsRecord> => {
  switch (type) {
    case MatchEventPenaltyShootout_KickType.MISS:
      return pxIcon(
        24,
        "https://images.onefootball.com/cw/icons/close-alternate.svg",
      );

    case MatchEventPenaltyShootout_KickType.GOAL: {
      return pxIcon(24, "https://images.onefootball.com/cw/icons/check.svg");
    }

    case MatchEventPenaltyShootout_KickType.UNRECOGNIZED: {
      return null;
    }
  }
};
